import {
  GET_EXTERNAL_PROJECTS_CATEGORIES_LOADING,
  GET_EXTERNAL_PROJECTS_CATEGORIES_SUCCESS,
  GET_EXTERNAL_PROJECTS_CATEGORIES_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { getExternalProjectCategoryUrl } from "api/apiUrls";

export const getExternalProjectsCategoriesActions =
  (page?: number, pageSize?: number) => async (dispatch: Dispatch) => {
    try {
      dispatch({
        type: GET_EXTERNAL_PROJECTS_CATEGORIES_LOADING,
        payload: true,
      });

      const response: any = await listItemsService(
        `${getExternalProjectCategoryUrl}`,
        `page=${page}&pageSize=${pageSize}`
      );

      dispatch({
        type: GET_EXTERNAL_PROJECTS_CATEGORIES_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({
        type: GET_EXTERNAL_PROJECTS_CATEGORIES_FAILURE,
        payload: err,
      });
    } finally {
      dispatch({
        type: GET_EXTERNAL_PROJECTS_CATEGORIES_LOADING,
        payload: false,
      });
    }
  };
